import React, { useState, useEffect } from "react";
import { Badge, Drawer, Card, Space, Button, Tag, Typography, Empty, Divider } from "antd";
import {
  BellOutlined,
  CloseOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { ExpenseServices } from "../../Services/Manage/ExpenseServices";
import { useNavigate } from "react-router-dom";

const QuickMessage = () => {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [dateRange, setDateRange] = useState("30_day");
  const navigate = useNavigate();

  useEffect(() => {
    fetchRecentExpenses(dateRange);
  }, [dateRange]);

  const fetchRecentExpenses = async (range) => {
    try {
      const res = await ExpenseServices.getFollowupData(range);

      if (res.status && res.data) {
        const enquiryList =
          res.data.enquiry?.map((item) => ({
            ...item,
            type: "ENQUIRY",
            key: `enq-${item.id}`,
          })) || [];

        const quoteList =
          res.data.quote?.map((item) => ({
            ...item,
            type: "QUOTE",
            key: `quo-${item.id}`,
          })) || [];

        setNotifications([...enquiryList, ...quoteList]);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([]);
    }
  };

  const handleExport = (item) => {
    if (item.type === "ENQUIRY") {
      navigate("/enquiry");
    }

    if (item.type === "QUOTE") {
      navigate("/quotation/edit", {
        state: { qu_no: item.qu_no },
      });
    }
  };

  const handleCloseNotification = (key) => {
    setNotifications((prev) => prev.filter((item) => item.key !== key));
  };

  return (
    <>
      <Badge count={notifications.length} offset={[5, 0]}>
        <BellOutlined
          style={{ fontSize: 22, cursor: "pointer", color: "#3b94e2ff" }}
          onClick={() => setOpen(true)}
        />
      </Badge>

      <Drawer
        title={<b>Notifications</b>}
        placement="right"
        open={open}
        onClose={() => setOpen(false)}
        width={420}
      >
        <Divider>Follow up date</Divider>
        <Space style={{ marginBottom: 12 }}>
          <Button
            type={dateRange === "1_day" ? "primary" : "default"}
            onClick={() => setDateRange("1_day")}
          >
            Today
          </Button>

          <Button
            type={dateRange === "7_day" ? "primary" : "default"}
            onClick={() => setDateRange("7_day")}
          >
            Upcoming 7 Days
          </Button>

          <Button
            type={dateRange === "30_day" ? "primary" : "default"}
            onClick={() => setDateRange("30_day")}
          >
            Upcoming 30 Days
          </Button>
        </Space>


        {notifications.length > 0 ? (
          notifications.map((item) => (
            <Card
              key={item.key}
              size="small"
              style={{
                borderRadius: 10,
                marginBottom: 12,
                border:
                  item.type === "ENQUIRY"
                    ? "1px solid #60a5fa"
                    : "1px solid #34d399",
                background:
                  item.type === "ENQUIRY" ? "#eff6ff" : "#ecfdf5",
                position: "relative",
              }}
            >
              {/* Close */}
              {/* <CloseOutlined
                onClick={() => handleCloseNotification(item.key)}
                style={{
                  position: "absolute",
                  top: 8,
                  right: 10,
                  color: "#999",
                  cursor: "pointer",
                }}
              /> */}

              {/* Export */}
              <ExportOutlined
                onClick={() => handleExport(item)}
                style={{
                  position: "absolute",
                  top: 8,
                  right: 32,
                  color: "#555",
                  cursor: "pointer",
                }}
              />

              {/* Header */}
              <Space style={{ marginBottom: 6 }}>
                <Tag color={item.type === "ENQUIRY" ? "blue" : "green"}>
                  {item.type}
                </Tag>
              </Space>

              {/* CONTENT */}
              {item.type === "QUOTE" ? (
                <>
                  <div><b>Quotation No:</b> {item.qu_no}</div>
                  <div><b>Follow-up:</b> {item.n_follow_up}</div>
                  <div><b>Created:</b> {item.added_on}</div>
                  <div><b>Updated:</b> {item.updated_on}</div>
                </>
              ) : (
                <>
                  <div><b>Enquiry ID:</b> {item.eq_id}</div>
                  <div><b>Description:</b> {item.eq_description}</div>
                  <div><b>Follow-up:</b> {item.n_follow_up}</div>
                  <div><b>Created:</b> {item.eq_date}</div>
                  <div><b>Updated:</b> {item.updated_on}</div>
                </>
              )}
            </Card>
          ))
        ) : (
          <Empty
            image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
            styles={{ image: { height: 160, marginTop: '100px' } }}
            description={
              <Typography.Text>
                No follow-ups found.
              </Typography.Text>
            }
          ></Empty>
        )}
      </Drawer>
    </>
  );
};

export default QuickMessage;
